// @flow
import _ from 'lodash'
import Switcher from '../controls/Switcher'
import React, { Component } from 'react'
import translations from '../../shared/translations.ru'
import type { Options as OptionsType } from '../types'
import LabeledWrapper from './LabeledWrapper'

type Props = {|
  options: OptionsType,
  value: string,
  onChange?: Function
|}

export default class GenderSelect extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={translations.gender_select.label}>
        <Switcher
          options={_.map(this.props.options, ([name, id]) => ({ id, name }))}
          value={this.props.value}
          onChange={(value) => this.valueChanged(value)}
        />
      </LabeledWrapper>
    )
  }

  valueChanged(value: string) {
    this.props.onChange && this.props.onChange(value)
  }
}
